var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#4e8278",
    height: 800,
    width: 800,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 382.117 382.117",
    stroke: "#4e8278"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.764 45.945H45.354C20.346 45.945 0 65.484 0 89.5v203.117c0 24.016 20.346 43.555 45.354 43.555h291.41c25.008 0 45.353-19.539 45.353-43.555V89.5c0-24.016-20.345-43.555-45.353-43.555zm0 251.775H45.354c-3.676 0-6.9-2.384-6.9-5.103V116.359l131.797 111.27a15.014 15.014 0 009.676 3.538l22.259.001c3.536 0 6.974-1.257 9.677-3.539l131.803-111.274v176.264c-.002 2.717-3.227 5.101-6.902 5.101zM191.059 192.987L62.87 84.397h256.378l-128.189 108.59z"
  })));
}
export default SvgEnvelope;